module.exports = __webpack_public_path__ + "static/media/shareToFbExample.cc2e31ce.png";